import { render, staticRenderFns } from "./DeTreeSelect.vue?vue&type=template&id=63d36495&scoped=true&"
import script from "./DeTreeSelect.vue?vue&type=script&lang=js&"
export * from "./DeTreeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d36495",
  null
  
)

export default component.exports